module.exports = __webpack_public_path__ + "static/352061de.supply4.png";